module.exports = __webpack_public_path__ + "img/NL590.b7ac3d92.svg";